<!--
    @公共文件头
-->
<template>
	<div class="common_header">
		<!-- <h2>列表搜索</h2> -->
		<div class="search">
               <div class="pageTitle">{{pageTitle}}</div>
                <div class="searchRight">
                <el-input class="my_input centerSearch" :placeholder="placeholderArea" v-model="searchKey" @keyup.enter.native="searchClick" clearable></el-input>
                <el-button type="primary"  class="rightSearchBtn height_four" @click="searchClick">搜索</el-button>
                <el-button type="text" class="height_four"  @click="openClick">高级搜索
                    <span class="el-icon-arrow-down" v-if="!showFlag"></span>
                    <span class="el-icon-arrow-up" v-else></span>
                </el-button>
               </div>
		</div>
		<!-- <div class="my_nav" v-if="tabs"> -->
			<!-- @click="navClick(item.value)" -->
			<!-- <span :class="item.value==navActive?'active':null"
				v-for="(item,i) in navList" :key="i" 
			>{{item.text}}
				<i class="badge_defult" :class="datacount[item.value]&&datacount[item.value]>0?'badge_red':null">{{datacount[item.value]|more99Filter}}</i>-->
				<!-- <i v-if="type==3">{{projectSetNum(item.value)}}</i> -->
				<!-- <template v-if="type==3">
					<i class="badge_defult" :class="datacount.GC&&datacount.GC>0?'badge_red':null" v-if="item.value=='1'">{{datacount.GC|more99Filter}}</i>
					<i class="badge_defult" :class="datacount.CG&&datacount.CG>0?'badge_red':null" v-if="item.value=='2'">{{datacount.CG|more99Filter}}</i>
					<i class="badge_defult" :class="datacount.GT&&datacount.GT>0?'badge_red':null" v-if="item.value=='3'">{{datacount.GT|more99Filter}}</i>
					<i class="badge_defult" :class="datacount.CQ&&datacount.CQ>0?'badge_red':null" v-if="item.value=='4'">{{datacount.CQ|more99Filter}}</i>
					<i class="badge_defult" :class="datacount.QT&&datacount.QT>0?'badge_red':null" v-if="item.value=='5'">{{datacount.QT|more99Filter}}</i>
				</template> -->
			<!-- </span>
		</div> -->
	</div>
</template>

<script>
import { mapState } from "vuex";
export default {
	props:{
		// 头类型 1待办事项清单 2今日开标项目 3项目跟踪 5招标计划
		type:{
			type:Number,
			default:1
		},
		datacount:{
			type:Object,
			default:function(){
				return {};
			}
		},
		tabs:{
			type:Boolean,
			default:true
		},
        pageTitle:{
            type:String,
			default:''
        }
	},
	data(){
		return {
			placeholderArea:'',
			navList:[],
			navActive:1,
			searchKey:'',
			showFlag:false,
			tradeId:''
		}
	},
	created(){
		if(this.type==1){
			this.navActive='';
		}else if(this.type==2){
			this.navActive='GC';
		}else if(this.type==3){
			this.navActive='GC';
		}
		sessionStorage.setItem('witnessHisBusinessType',this.navActive)
		this.placeholderFn();
		this.setNav();
		this.$bus.$on('changeSearch',(value)=>{
            this.searchKey='';
			this.searchClick()
        })
	},
    computed:{
      ...mapState({
		isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
    }),
    },
	methods:{
		// 设置搜索框的placeholder
		placeholderFn(){
			let temp={
				1:'请输入项目名称或项目编号',
				2:'请输入项目名称/项目编号/招标人名称/中标人名称',
                3:'请输入项目名称/项目编号/招标人名称/中标人名称',
                5:'请输入项目名称/招标人名称',
			}
			this.placeholderArea=temp[this.type];
		},
		// 设置nav菜单
		setNav(){
			let temp={
				1:[{
						text:'全部',
						value:''
					},
					{
						text:'工程建设',
						value:'GC'
					},
					{
						text:'政府采购',
						value:'CG'
					},
					{
						text:'国土交易',
						value:'GT'
					},
					{
						text:'国有产权',
						value:'CQ'
					},
					// {
					// 	text:'其他（含现场督办）',
					// 	value:'5'
					// }
					],
				2:[{
						text:'工程建设',
						value:'GC'
					},
					{
						text:'政府采购',
						value:'CG'
					},
					{
						text:'国土交易',
						value:'GT'
					},
					{
						text:'国有产权',
						value:'CQ'
					},
					// {
					// 	text:'其他（含现场督办）',
					// 	value:'5'
					// }
					],
				3:[{
						text:'工程建设',
						value:'GC'
					},
					{
						text:'政府采购',
						value:'CG'
					},
					{
						text:'国土交易',
						value:'GT'
					},
					{
						text:'国有产权',
						value:'CQ'
					},
					// {
					// 	text:'其他（含现场督办）',
					// 	value:'QT'
					// }
					],
                5:[{
                    text:'工程建设',
                    value:'GC'
                },
                    {
                        text:'政府采购',
                        value:'CG'
                    },
                    {
                        text:'国土交易',
                        value:'GT'
                    },
                    {
                        text:'国有产权',
                        value:'CQ'
                    },
                    // {
                    // 	text:'其他（含现场督办）',
                    // 	value:'QT'
                    // }
                ]
			}
			this.navList=temp[this.type];
		},
		// nav点击事件
		navClick(value){
			this.navActive!=value && this.$emit('navchange',value);
			this.navActive=value;
			window.sessionStorage.setItem('witnessHisBusinessType',value)
		},
		// 搜索按钮
		searchClick(){
			this.$emit('searchclick',this.searchKey,this.tradeId)
		},
		openClick(){//高级搜索
			this.showFlag=!this.showFlag;
			this.$emit('showBox',this.showFlag)
		}
		// 项目跟踪设置菜单的数量
		// projectSetNum(item){
		// 	let projectList={'1':'GC','2':'CG','3':'GT','4':'CQ','5':'QT'};
		// 	Object.keys(projectList).forEach(key=>{
		// 		if(item==key){
		// 			console.log(data[projectList[key]])
		// 			return data[projectList[key]]
		// 		}
		// 	})
		// }
	}
}
</script>
<style lang="scss">
.common_header{
    .search{
        .el-input .el-input__inner, .el-input--medium .el-input__inner, .el-input--suffix .el-input__inner{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            }
    .rightSearchBtn{
        height:40px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    .height_four{
        height: 40px;
    }
     .el-input--medium .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
    }
 
}
</style>
<style lang="scss" scoped>
// $main-color:#1890FF;
$main-color:#1890FF;
.common_header{
    .pageTitle{
        font-size: 18px;
        font-weight: 600;
        color: #000000; 
        height: 40px; 
    }
	// box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
	>h2{
		margin-bottom: 30px;
		font-weight: bold;
	}
	>.search{
        display: flex;
		align-items: center;
        .searchRight{
	    display: flex;
		justify-content: center;
		align-items: center;
        width:calc(100% - 162px);
        >.my_input{
			width: 500px;
		}
     
        }
		>.el-button--primary{
			background-color: $main-color;
			border-color: $main-color;
		}
	}
	>.my_nav{
		margin-top: 30px;
		>span{
			padding: 10px;
			cursor: pointer;
			position: relative;
			>i{
				font-style: normal;
				margin-left: 1px;
			}
			&:after{
				content: '';
				width: 0%;
				height: 2px;
				background: #1890FF;
				position: absolute;
				bottom: 0;
				left: 0;
				transition: all 0.7s;
			}
			&:hover{
				color: #1890FF;
			}
			&:hover:after{
				width: 100%;
			}
		}
		>.active{
			color: #1890FF;
			&:after{
				content: '';
				width: 100%;
				height: 2px;
				background: #1890FF;
				position: absolute;
				bottom: 0;
				left: 0;
			}
		}
	}
}
</style>
